import { Component, OnInit } from '@angular/core';
// services
import { ActivatedRoute } from '@angular/router';
import { MasterService } from '../../../../services/master.service';
import { MessageService } from '../../../../services/message.service'
import { StoreService } from '../../../../services/store.service'
import * as languageLibrary from '../../../../services/language'

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss'],
    standalone: false
})
export class HistoryComponent implements OnInit {
    /*
    * variables
    */
    // save the language
    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'

    // set all words
    protected words = languageLibrary.language

    // define if is loading
    protected loading: boolean = false

    /*
    * Life cycles
    */
    constructor(private route: ActivatedRoute, private master: MasterService, private ms: MessageService, protected store: StoreService) { }

    ngOnInit() {

    }

    // todo: listen to output of navbar
    public listenerNav = (e): void => {
        switch (e['message']) {
            case 'changeLanguage':
                this.language = e['value']
                break;
            default:
                break;
        }
    }
}
